(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["labmond-booking-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href*="/products/book-your-appointment"]');
  if (!link || !location.pathname.includes('/pages/virtual-appointments')) return;
  const card = link.closest('[class*="ServicesList__Card-sc"]');
  const button = card && card.querySelector('.book-button');
  if (!button) return;
  event.preventDefault();
  button.click();
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["labmond-inquiry"] && !Shopify.designMode) return;
  try {
    function syncInquiryOptions(dialog, section) {
    dialog.querySelectorAll('[data-inquiry-option]').forEach(function(field) {
      const index = field.dataset.inquiryOption;
      const selected = section.querySelector('input[data-index="' + index + '"]:checked, select[data-index="' + index + '"]');
      field.value = selected ? selected.value : '';
      const display = dialog.querySelector('[data-inquiry-display="' + index + '"]');
      const labels = dialog.querySelector('[data-inquiry-labels="' + index + '"]');
      const values = labels ? JSON.parse(labels.textContent) : {};
      if (display) display.value = Object.prototype.hasOwnProperty.call(values, field.value) ? values[field.value] : field.value;
    });
}
document.addEventListener('variantChange', function(event) {
  const section = event.target.closest('.product-section');
  if (!section) return;
  section.querySelectorAll('.lbm-inquiry').forEach(function(dialog) {
    syncInquiryOptions(dialog, section);
    dialog.querySelector('[data-inquiry-variant]').value = event.detail && event.detail.variant ? event.detail.variant.id : '';
  });
}, true);
document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-inquiry-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.inquiryOpen);
    const section = opener.closest('.product-section');
    if (!dialog || !section) return;
    syncInquiryOptions(dialog, section);
    const variant = section.querySelector('[data-product-select]');
    if (variant) dialog.querySelector('[data-inquiry-variant]').value = variant.value;
    const size = section.querySelector('select[data-product-ring-size], input[data-product-ring-size]:checked');
    const sizeField = dialog.querySelector('[data-inquiry-size]');
    if (size && sizeField) {
      if (!Array.from(sizeField.options).some(option => option.value === size.value)) sizeField.add(new Option(size.value, size.value));
      sizeField.value = size.value;
    }
    dialog.showModal();
  }
  if (event.target.closest('[data-inquiry-close]')) event.target.closest('dialog').close();
  if (event.target.matches('dialog.lbm-inquiry')) {
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  }
});
document.querySelectorAll('.lbm-inquiry').forEach(function(dialog) {
  if (dialog.querySelector('[data-inquiry-result]')) dialog.showModal();
});
  } catch(e) { console.error(e); }
})();

})();
